<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <v-card-title class="display-3">
            Профиль участника
          </v-card-title>
          <v-card-subtitle>Заполните все поля в кладках ПРОФИЛЬ и ЛОЯЛЬНОСТЬ для участия в программе лояльности</v-card-subtitle>
          <v-divider />
          <v-tabs
            v-model="currentTab"
            show-arrows
          >
            <v-tab>Профиль</v-tab>
            <v-tab @change="onChangeTab">
              Лояльность
            </v-tab>
            <v-tab>Пароль</v-tab>
            <v-tab-item :eager="true">
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    sm="12"
                  >
                    <v-text-field
                      v-model="userProfile.name"
                      outlined
                      prepend-inner-icon="mdi-account"
                      :rules="[
                        () => !!userProfile.name || 'Поле требует заполнения',
                      ]"
                      label="Имя"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    sm="12"
                  >
                    <v-text-field
                      v-model="userProfile.surname"
                      outlined
                      prepend-inner-icon="mdi-account-plus"
                      :label="'Фамилия'"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <!--                  :v-model="userProfile.phone | vMask('# (###) ##-###-##')"-->
                    <v-text-field
                      v-mask="'+#(###)##-###-##'"
                      outlined
                      prepend-inner-icon="mdi-phone-classic"
                      :value="userProfile.login"
                      hint="формат - +# (###) ##-###-##"
                      label="Телефон "
                      placeholder="+# (###) ##-###-##"
                      @input="(value) => (userProfile.login = value)"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="userProfile.email"
                      outlined
                      prepend-inner-icon="mdi-email"
                      label="Эл. почта"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    Зарегистрироваться в
                    <a
                      :href="this.telegramUrl"
                      target="_blank"
                    >telegram bot </a> для уведомлений
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-row
                  align-content="space-between"
                  justify="space-around"
                >
                  <v-btn
                    color="primary"
                    @click="onSave()"
                  >
                    Сохранить
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-tab-item>
            <v-tab-item :eager="true">
              <v-card>
                <user-profile-form
                  v-model="attrSaved"
                  :customer-id="customerId"
                  :user-profile-id="userProfile.userProfileId"
                  @fill="onAllFieldFilled"
                  @validate="onValidate"
                />
                <v-card-actions class="d-flex justify-center">
                  <v-btn
                    :disabled="!isLoyaltyFormValidated"
                    color="primary"
                    @click="onSaveLoyalty"
                  >
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-form
                  ref="form"
                  v-model="validChangePassword"
                >
                  <v-card-title>
                    Смена пароля
                  </v-card-title>
                  <v-card-text>
                    <v-row class="d-flex flex-column justify-center align-center">
                      <v-col
                        cols="6"
                        class="center"
                      >
                        <v-text-field
                          v-model="form.oldPassword"
                          outlined
                          label="Старый пароль"
                          :error="errorOldPassword"
                          :error-messages="errorMessageOldPassword"
                          :rules="[v => !!v || 'Пароль обязателен']"
                          :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showOldPassword ? 'text' : 'password'"
                          @click:append="showOldPassword = !showOldPassword"
                          @focus="errorOldPassword=false; errorMessageOldPassword=[]"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.password"
                          outlined
                          label="Новый пароль"
                          :rules="passwordRules"
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          @click:append="showPassword = !showPassword"
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          v-model="form.password2"
                          outlined
                          label="Повторить"
                          :rules="passwordRules"
                          :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword2 ? 'text' : 'password'"
                          @click:append="showPassword2 = !showPassword2"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions class="d-flex justify-center">
                    <v-btn
                      color="primary"
                      :disabled="!validChangePassword || form.password !== form.password2"
                      @click="onChangePassword"
                    >
                      Сменить
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePicker from "../../shared/components/date-picker/DatePicker"
import WebApi from "../../shared/modules/web_api"
import { UserProfileModel } from "../../models/user-profile.model"
import ParticipantList from "../participant/ParticipantList"
import { TheMask } from "vue-the-mask"
import UserProfileForm from "@/views/loyalty/components/user_profile/UserProfileForm"
import { EncodeService } from "@/views/loyalty/shared/services/encode-service"

export default {
  name: "UserProfileEdit",
  components: {
    UserProfileForm,
    DatePicker,
    ParticipantList,
    TheMask
  },
  data: () => ({
    attrSaved: false,
    currentTab: 0,
    customerId: "",
    isLoyaltyFormValidated: false,
    dialogVisible: false,
      encodeService: null,
    errorOldPassword: false,
    errorMessageOldPassword: [],
    isAllFieldFilled: false,
    form: {
      oldPassword: '',
      password: '',
      password2: ''
    },
    role: 0,
    onSaveAttr: false,
    passwordRules: [
      v => !!v || 'Пароль обязателен',
      v => (v && v.length >= 6) || 'Пароль должен содержать, не менее 6 символов',
    ],
    showOldPassword: false,
    showPassword: false,
    showPassword2: false,
      telegramUrl: null,
    userProfile: {},
    validChangePassword: false,
    webApi: null
  }),
  async beforeMount () {
    // console.clear()
    this.webApi = new WebApi(this.$store)
        .editSuccess("Профиль пользователя сохранен успешно!")
        .editError("Ошибка при сохранении профиля пользователя")
        .readError("Ошибка при загрузке профиля пользователя")
    console.log("this.$store", this.$store.state)
      this.encodeService = new EncodeService()
    // this.customerId = this.$route.params.customer
    // this.customerId = this.$store.getters["customer_store/getCustomerId"]

    this.userProfile.userProfileId = localStorage.getItem('userProfileId')
    // this.login = this.$store.getters['login_store/getLogin']
    this.login = localStorage.getItem('login').replace(/[+()-]/g, '')
    console.log('this.login=' + this.login)

    // get UserProfile
    const response = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/user_profile/login/${this.login}`)
      console.log('response', response)
      this.userProfile = Reflect.construct(UserProfileModel, [response])
      console.log('userProfile', this.userProfile)

    this.customerId = localStorage.getItem('customer')
    console.log('this.customerId=' + this.customerId)
      this.telegramUrl = await this.encodeService.encodeUserNumber(this.userProfile.number)
      // this.telegramUrl = `https://t.me/payjust_u_bot?start=${encoded_user_number}`
      console.log('this.telegramUrl=', this.telegramUrl)
    // get company data
    /* response = await this.webApi.post(`${process.env.VUE_APP_JUSTPAY_URL}api/client/get`, { id: this.customerId })
          if (!response.error) {
            // this.select.users = response.data
            console.log('this.select.users', response.data)
          } else {

          } */
  },
  methods: {
    // create () {
    //   console.log(this.userProfile)
    //   console.log(`this.customerId=${this.customerId}`)
    //   this.webApi
    //       .post(
    //           `${process.env.VUE_APP_LOYALTY_URL}user_profile/` + this.customerId,
    //           this.userProfile
    //       )
    //       .then(response => {
    //         console.log(`response=${JSON.stringify(response)}`)
    //         this.userProfile.userProfileId = response.userProfileId
    //         this.isCreating = false
    //       })
    //       .catch(error => {
    //         console.error(error)
    //       })
    // },
    // back () {
    //   this.$router.back()
    // },
    getUser (user) {
      console.log(user.fio)
      // Get UserProfile
      this.webApi
          .get(`${process.env.VUE_APP_LOYALTY_URL}user_profile/` + user.userId)
          .then(data => {
            console.log("user_profile", data)
            this.userProfile = Reflect.construct(UserProfileModel, [data])

            console.log("this.userProfile", this.userProfile)
          })
    },
    onAllFieldFilled (isAllFieldFilled) {
      console.log('isAllFieldFilled', isAllFieldFilled)
      this.isAllFieldFilled = isAllFieldFilled
      // if (isAllFieldFilled) {
      //   this.$router.push({ name: 'Crowd' })
      // }
    },
    onChangePassword () {
      this.webApi.put(
          `${process.env.VUE_APP_LOYALTY_URL}api/user_profile/${this.userProfile.userProfileId}`,
          { oldPassword: this.form.oldPassword, password: this.form.password },
      ).then(response => {
        console.log('response', response)
        if (response.status_code !== 200) {
          this.form.oldPassword = ''
          this.$refs.form.reset()
          // this.$refs.form.validate()
          this.errorOldPassword = true
          this.errorMessageOldPassword = ['Пароль не верен']
        } else {
          if (this.isAllFieldFilled) {
            this.$router.push({ name: 'Crowd' })
          } else {
            this.currentTab = 1
          }
        }
      }).catch((e) => {
        console.error('->', e)
})
    },
    onChangeTab () {
      if (!this.customerId) {
        this.customerId = localStorage.getItem('customer')
      }
    },
    onValidate (isLoyaltyFormValidated) {
      this.isLoyaltyFormValidated = isLoyaltyFormValidated
    },
    async onSave () {
      const userProfile = await this.webApi.patch(
          `${process.env.VUE_APP_LOYALTY_URL}api/user_profile/`,
          this.userProfile
      )
      this.userProfile = Reflect.construct(UserProfileModel, [userProfile])
      console.log('userProfile:', this.userProfile)
      if (this.userProfile.isAllFieldFilled()) {
        if (this.isAllFieldFilled) {
          await this.$router.push({ name: 'Crowd' })
        } else {
          this.currentTab = 1
        }
      }
    },
    onSaveLoyalty () {
      this.attrSaved = true
      if (this.userProfile.isAllFieldFilled()) {
        this.$router.push({ name: 'Crowd' })
      } else {
        this.currentTab = 0
      }
    }

  }
  }
</script>

<style scoped></style>
